// @flow
import { makeGetRequest } from '../utils'

import type { ResponseAPI } from '../types/api'
import type { Channels } from '../types/channels'

export const getChannelsBrief = (domain: string, serviceSpec: string): Promise<ResponseAPI<Channels>> =>
  makeGetRequest(`${domain}/client/api/servicespec/${serviceSpec}/tv/channels?brief`)
